<template>
  <div class="filters-wrap !tw-flex">
    <ElPopover
      v-model:visible="filterOpen"
      placement="bottom"
      popper-class="filter-fixed-wrap"
      width="327"
      trigger="click"
    >
      <template v-slot:reference>
        <button
          :disabled="disabled"
          :class="{ 'btn-primary': filterOpen || firstFilter.values || sub_affiliate_id || filter_active,
                    'btn-outline-primary': !filterOpen,
                    'btn-events-none': filterOpen,
                    'btn-mob-content': (sub_affiliate_id && sub_affiliate_id !== '0')}"
          class="btn btn-refresh btn-sm !tw-flex"
        >
          <span class="!tw-flex !tw-items-center">
            <i class="fas fa-filter mr-4" />
            {{ $t('filters.filter') }}
            <span class="length-filter pl-2">{{ calcLengthFilters() }}</span>
          </span>
          <span
            v-if="sub_affiliate_id && sub_affiliate_id !== '0'"
            class="btn-filter-email"
          >{{ sub_affiliate_email }}</span>
        </button>
      </template>

      <div
        v-if="filterOpen"
        v-loading="loadingSelect"
        class="filter-fixed"
      >
        <div class="select-block-wrap select-block-head-wrap mb-16">
          <span class="!tw-flex !tw-items-center">
            <div
              class="cross"
              @click="filterOpen = false"
            >×</div>{{ $t('filters.filter') }}
          </span>
          <div
            v-if="firstFilter.values || (sub_affiliate_id && sub_affiliate_id !== '0') || filter_active"
            class="reset-filters text-red"
            @click="resetFilters"
          >
            {{ $t('filters.resetFilters') }}
          </div>
        </div>

        <div
          v-if="$store.state.profile.user.referral_program_enabled"
          class="filters-border-bottom mt-16 mb-16"
        >
          <UiSelect
            v-if="!mbFilter"
            v-model="sub_affiliate_id"
            :label="$t('filters.subaffiliate')"
            :placeholder="$t('filters.selectSA')"
            :list="referrals"
            is-search
            type="filter"
            :teleported="false"
            :remote-search="subAffFromServer"
            mobile-shift-fix
            @change="currentFilters.map(e => e.values = '')"
          />
          <UiSelectGroup
            v-else
            v-model="traffic_filter_name"
            :label="$t('filters.traffic')"
            :placeholdr="$t('filters.total')"
            :list="traffic_list"
            is-search
            type="filter"
            :teleported="false"
            @change="changeTraffic"
          />
        </div>
        <template
          v-for="(item, id) in filtersBasic"
          :key="id"
        >
          <UiSelect
            v-model="item.filter.values"
            class="filters-wrap__select"
            :label="item.title"
            :list="item.options"
            :empty-values="[null]"
            :value-on-clear="null"
            is-search
            type="filter"
            :multiple="item.multiple"
            :teleported="false"
            mobile-shift-fix
            :disabled="isFiltersDisabled"
          />
        </template>

        <div
          class="select-block-wrap"
          :class="{'select-opacity': isFiltersDisabled}"
          @click="expandSubids = !expandSubids"
        >
          <span class="pl-16">
            SubID
          </span>

          <div class="!tw-flex !tw-items-center text-expand text-green pr-16">
            <template v-if="expandSubids">
              {{ $t('customReports.hide') }} <div class="plus ml-8 mb-2">
                -
              </div>
            </template>
            <template v-else>
              {{ $t('customReports.show') }} <div class="plus ml-8 mb-2">
                +
              </div>
            </template>
          </div>
        </div>

        <div v-if="expandSubids">
          <UiSelect
            v-for="(item, id) in filtersSubid"
            :key="id"
            v-model="item.filter.values"
            :label="item.title"
            :list="item.options"
            :empty-values="[null]"
            :value-on-clear="null"
            is-search
            type="filter"
            :multiple="item.multiple"
            :disabled="isFiltersDisabled"
            :teleported="false"
            mobile-shift-fix
          />
        </div>

        <div class="!tw-flex pl-16 pr-16 mb-16 mt-16">
          <button
            class="btn btn-primary btn-refresh !tw-w-full"
            :class="{'not-disabled': (firstFilter.values || (sub_affiliate_id && sub_affiliate_id !== '0') || filter_active)}"
            :disabled="!(firstFilter.values || (sub_affiliate_id && sub_affiliate_id !== '0') || filter_active) && !isFiltersChanged()"
            @click="applyFilters"
          >
            <span class="before-icon">{{ $t('filters.applyFilters') }}</span>
          </button>

          <button
            v-if="firstFilter.values || (sub_affiliate_id && sub_affiliate_id !== '0') || filter_active"
            class="btn btn-outline-danger btn-sm ml-8 !tw-w-full"
            @click="resetFilters"
          >
            <span class="text-red">×</span>
            {{ $t('filters.resetFilters') }}
          </button>
        </div>
      </div>
    </ElPopover>

    <div
      v-if="firstFilter.values || (sub_affiliate_id && sub_affiliate_id !== '0') || filter_active"
      class="reset-filters text-red ml-8"
      @click="resetFilters"
    >
      {{ $t('filters.resetFilters') }}
    </div>
  </div>
</template>

<script>
import InjectPlugins from '@/components/Report/Components/inject-plugins';
import { debounce } from '@/lib/lodash';

export default {
  mixins: [InjectPlugins],
  props: {
    useFilters: Array,
    modelValue: Array,
    currency: {
      type: String,
      default: '$',
    },
    from: String,
    to: String,
    filterId: [String, Object, Array],
    mbFilter: Boolean,
    defaultFilter: {
      type: Object,
      default() {
        return {};
      },
    },
    accumulative: {
      type: [String, Boolean],
      default() {
        return false;
      },
    },
    myAccount: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update', 'update:model-value'],

  data() {
    return {
      disabled: false,
      currentFilters: [
        { type: 'traffic_source_id', values: '' },
        { type: 'country_code', values: '' },
        { type: 'site_player_id', values: '' },
        { type: 'affiliate_offer_id', values: '' },
        { type: 'subid1', values: '' },
        { type: 'subid2', values: '' },
        { type: 'subid3', values: '' },
        { type: 'subid4', values: '' },
        { type: 'subid5', values: '' },
      ],
      sub_affiliate_id: '',
      filterOptionsBase: {},
      filterOpen: false,
      loadingSelect: false,
      expandSubids: false,
      stateApply: false,
      sub_affiliate_id_old: '',
      currentFilters_old: [],
      blockPupop: {},
      traffic_filter: 'all',
      traffic_filter_name: 'all',
      traffic_filter_old: '',
      filter_active: false,
      search_traffic: '',
      select: debounce(this.selected, 300),
      paramsChanged: true,
      initialFilters: {},
    };
  },
  mounted() {
    this.select();
    this.blockPupop = document.querySelector('.filter-fixed-wrap');
    this.saveInitialFilters();
  },
  activated() {
    this.select();
  },
  watch: {
    sub_affiliate_id() {
      this.$nextTick(() => {
        this.resetOptions();
      });
    },
    traffic_filter_name() {
      if (this.traffic_filter_old !== 'own') this.filter_active = this.traffic_filter_name !== this.traffic_filter_old;
    },
    async filterOpen() {
      this.search_traffic = '';
      if (this.filterOpen) {

        this.loadingSelect = true;
        await this.getCurrentFilters();
        this.sub_affiliate_id_old = this.sub_affiliate_id;
        this.traffic_filter_old = this.traffic_filter_name;
        this.currentFilters_old = this.$_.cloneDeep(this.currentFilters);
        this.saveInitialFilters();
      }
      if (!this.filterOpen && !this.stateApply) {
        this.sub_affiliate_id = this.sub_affiliate_id_old;
        this.traffic_filter_name = this.traffic_filter_old;
        this.currentFilters = this.currentFilters_old;
      }
    },
    params: {
      deep: true,
      handler(value, oldValue) {
        if (!this.$_.isEqual(value, oldValue)) {
          this.paramsChanged = true;
        }
      },
    },
    accumulativeFilters() {
      this.$nextTick(() => {
        this.loadingSelect = true;
        this.getCurrentFilters();
      });
    },
  },

  methods: {
    subAffFromServer(search) {
      return this.$api.getSubAffiliates({
        limit: 100,
        offset: 0,
        search: search,
      }).then((data) => {
        return data.payload.map((obj) => ({
          id: obj.id,
          text: obj.email,
        }));
      });
    },
    saveInitialFilters() {
      this.initialFilters = {
        sub_affiliate_id: this.sub_affiliate_id,
        traffic_filter: this.traffic_filter,
        traffic_filter_name: this.traffic_filter_name,
        currentFilters: this.$_.cloneDeep(this.currentFilters.map(e => ({ type: e.type, values: e.values }))),
      };
    },
    isFiltersChanged() {
      const current = {
        sub_affiliate_id: this.sub_affiliate_id,
        traffic_filter: this.traffic_filter,
        traffic_filter_name: this.traffic_filter_name,
        currentFilters: this.currentFilters.map(e => ({ type: e.type, values: e.values })),
      };
      return !this.$_.isEqual(current, this.initialFilters);
    },
    resetFilters() {
      this.currentFilters.map((e) => e.values = '');
      this.sub_affiliate_id = '';
      this.traffic_filter = 'all';
      this.traffic_filter_name = 'all';
      this.stateApply = true;
      this.filterOpen = false;
      this.loadingSelect = false;
      this.$emit('update', [{}]);
      this.$emit('update:model-value', [{}]);
      this.$nextTick(() => {
        this.stateApply = false;
        this.filter_active = false;
        this.saveInitialFilters();
      });
    },
    applyFilters() {
      if (this.traffic_filter_name === 'all' && this.mbFilter) {
        this.resetFilters();
      }
      const event = JSON.parse(JSON.stringify([
        { sub_affiliate_id: this.sub_affiliate_id },
        { traffic_filter: this.traffic_filter },
        { traffic_filter_name: this.traffic_filter_name },
        ...this.currentFilters,
      ]));

      this.$emit('update', event);
      this.$emit('update:model-value', event);

      this.stateApply = true;
      this.filterOpen = false;
      this.loadingSelect = false;
      this.$nextTick(() => {
        this.stateApply = false;
        this.saveInitialFilters();
      });
    },

    getCurrentFilters() {
      if (!this.paramsChanged) {
        this.loadingSelect = false;
        return;
      }

      const params = this.hasOptionsFilters.map((e) => ({
        limit: 1000,
        offset: 0,
        metrics: ['visits_count', 'deposits_all_sum'],
        dimensions: [e.field],
        from: this.params.from,
        to: this.params.to,
        filters: this.params.filters,
      }));

      this.$api.postReport(params)
        .then((res) => {
          this.filterOptionsBase = {};

          res.payload.data.forEach((e) => {
            if (e[0] && e[0].row_filter_column) {
              this.$set(this.filterOptionsBase, e[0].row_filter_column, [
                ...e,
              ]);
            }
          });

          this.loadingSelect = false;
          this.paramsChanged = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingSelect = false;
        });
    },

    resetOptions() {
      this.loadingSelect = true;
      this.getCurrentFilters();
    },

    selected() {
      if (this.modelValue) {
        this.$nextTick(() => {
          this.modelValue.map((item) => {
            if (item.sub_affiliate_id) {
              this.sub_affiliate_id = item.sub_affiliate_id;
            }
            if (item.traffic_filter) {
              this.traffic_filter = item.traffic_filter;
            }
            if (item.traffic_filter_name) {
              this.traffic_filter_name = item.traffic_filter_name;
            }
            const index = this.currentFilters.map((e) => e.type).indexOf(item.type);
            if (index !== -1) this.currentFilters.splice(index, 1);
            if (item.type) {
              this.disabled = true;
              this.currentFilters.push(item);
              this.disabled = false;
              this.currentFilters = this.currentFilters.filter((e) => e.type);
              if (!this.currentFilters.length) this.currentFilters = [];
            }
            if (!this.currentFilters.length) this.currentFilters = [];
          });
        });
      }
    },
    calcLengthFilters() {
      const length = this.currentFilters.filter((e) => e.values !== '').length;
      return length ? `(${length})` : '';
    },
    changeTraffic(v) {
      this.currentFilters.map((e) => e.values = '');
      this.traffic_filter = this.traffic_filter_name;
      if (v !== 'own' && v !== 'all') {
        this.traffic_filter = 'sub_affiliate';
        this.sub_affiliate_id = v;
      } else {
        this.sub_affiliate_id = '';
      }
    },
  },

  computed: {
    // sub_affiliate filter
    // subAffiliates() {
    //   const subAffiliates = this.filterOptionsBase.affiliate_id || [];
    //   return subAffiliates.filter((item) => item.row_id);
    // },
    subAffiliates() {
      const data = this.$store.state.subaffiliates.all.map((e) => ({
        id: e.data.id,
        text: e.email,
      }));

      if (this.myAccount) {
        data.unshift({
          id: '',
          text: this.$t('mediaBuying.campaign.my_account'),
        });
      }

      return data;
    },
    traffic_list() {
      const dif = [];
      let list = [{
        label: '',
        options: [{
          id: 'all',
          text: this.$t('filters.total'),
        }, {
          id: 'own',
          text: this.$t('filters.own'),
        }],
      }, {
        label: this.$t('sidebar.menu.main.subAffiliates'),
        options: this.subAffiliates,
      }];

      if (this.search_traffic !== '') {
        list.forEach((e) => {
          e.options = e.options.filter((i) => i.text.toLowerCase().includes(this.search_traffic));
          if (e.options.length) dif.push(e);
        });
        list = dif;
      }
      return list;
    },
    referrals() {
      return this.subAffiliates;
    },
    sub_affiliate_email() {
      const result = this.$store.state.subaffiliates.all.find((e) => e.data && e.data.id === this.sub_affiliate_id);
      return result?.email;
    },
    firstFilter() {
      const onceValue = this.currentFilters.filter((e) => e.values !== '')[0];
      return onceValue || {};
    },
    defaultFilterOption() {
      return {
        id: '',
        text: this.$t('filters.all'),
      };
    },
    filterOptions() {
      const result = {};
      this.hasOptionsFilters.forEach((filter) => {
        const { param, field } = filter;
        const options = this.filterOptionsBase[param] || [this.defaultFilterOption];

        result[param] = options.map((e) => {
          const text = e[field];
          return {
            ...e,
            text: text
              ? e.row_filter_column === 'site_player_id'
                ? `${text} [${this.currency}${e.deposits_all_sum.toLocaleString('en-US', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })}]`
                : `${text} (${e.visits_count} ${this.$t('customReports.visits')})`
              : this.$t('filters.all'),
            id: e.row_id || '',
          };
        });
        const empty = this.$_.find(result[param], (item) => {
          return item.id === '';
        });
        if (!empty) {
          result[param].unshift({
            id: '',
            text: this.$t('filters.all'),
          });
        } else {
          empty.text = this.$t('filters.all');
        }
      });

      return result;
    },
    filtersMeta() {
      const base = [
        {
          type: 'custom',
          param: 'traffic_source_name',
          field: 'traffic_source_name',
          title: this.$t('filters.trafficSource'),
        },
        // sub_affiliate filter
        // {
        //   type: 'requestOnly',
        //   param: 'affiliate_id',
        //   field: 'sub_affiliate_email',
        //   title: ''
        // },
        {
          type: 'basic',
          param: 'traffic_source_id',
          field: 'traffic_source_name',
          title: this.$t('filters.trafficSource'),
        },
        {
          type: 'basic',
          param: 'country_code',
          field: 'country_name',
          title: this.$t('filters.country'),
        },
        {
          type: 'basic',
          param: 'site_player_id',
          field: 'site_player_id',
          title: this.$t('filters.players'),
          showCondition: () => this.useFilters.indexOf('player_id') !== -1,
        },
        {
          type: 'basic',
          param: 'affiliate_offer_id',
          field: 'affiliate_offer_name',
          title: this.$t('filters.offers'),
        },
      ];

      const subIdCount = 5;
      const subIds = Array.apply(null, { length: subIdCount })
        .map((item, index) => ({
          type: 'subid',
          param: `subid${index + 1}`,
          field: `subid${index + 1}`,
          title: `SubID ${index + 1}`,
        }));

      return base.concat(subIds);
    },
    hasOptionsFilters() {
      return this.filtersMeta
        .filter((item) => item.type !== 'custom');
    },
    filtersMetaFiltered() {
      return this.filtersMeta
        .filter((item) => item.type !== 'custom' && (!item.showCondition || item.showCondition()))
        .map((item) => ({
          ...item,
          options: this.filterOptions[item.param] || [],
          filter: this.currentFiltersIndex[item.param] || {},
        }));
    },
    currentFiltersIndex() {
      const result = {};
      this.currentFilters.forEach((item) => {
        result[item.type] = item;
      });
      return result;
    },
    filtersBasic() {
      return this.filtersMetaFiltered.filter((item) => item.type === 'basic');
    },
    filtersSubid() {
      return this.filtersMetaFiltered.filter((item) => item.type === 'subid');
    },
    isFiltersDisabled() {
      return this.traffic_filter_name === 'all' && this.mbFilter;
    },
    pAccumulative() {
      return this.accumulative || this.accumulative === '';
    },
    accumulativeFilters() {
      const result = {};

      if (this.pAccumulative) {
        this.currentFilters
          .filter((item) => item.values)
          .forEach((item) => {
            result[item.type] = {
              op: '=',
              value: item.values,
            };
          });
      }

      return result;
    },
    filters() {
      const result = {
        ...this.defaultFilter,
        ...this.accumulativeFilters,
      };

      if (this.sub_affiliate_id && this.sub_affiliate_id !== '') {
        result.affiliate_id = {
          op: '=',
          value: this.sub_affiliate_id,
        };
      }

      return result;
    },
    params() {
      return {
        from: this.from || new Date(new Date().setDate(1)),
        to: this.to || new Date(),
        filters: this.filters,
      };
    },
  },
};
</script>


<style lang="scss">
// дубликатов нет
@import 'src/assets/theme/default/components/filterReports';
</style>
